<svg height="50px" [attr.width]="(lineWidth * (extraSeries.length+1))">
    <g [attr.transform]="('translate(' + startingPos + ', 0)')">
        <!-- leftmost downward arrow -->
        <line x1="0" y1="0" x2="0" y2="40" stroke-width="2" stroke="black"></line>
        <line x1="0" y1="40" x2="-10" y2="30" stroke-width="2" stroke="black"></line>
        <line x1="0" y1="40" x2="10" y2="30" stroke-width="2" stroke="black"></line>

        <!-- arrow pointing to the right and down for each split -->
        @if (!manyToOne) {
            <ng-container>
                @for (series of extraSeries; track series; let i = $index) {
                    <g [attr.transform]="('translate(' + (lineWidth * i) + ', 0)')">
                        <!-- horizontal line spanning to next task group -->
                        <line x1="0" y1="20" [attr.x2]="lineWidth" y2="20" stroke-width="2" stroke="black"></line>
                        <!-- vertical line toward group -->
                        <line [attr.x1]="lineWidth"
                              y1="20"
                              [attr.x2]="lineWidth"
                              y2="40"
                              stroke-width="2"
                              stroke="black"></line>
                        <!-- arrow pointing down -->
                        <line [attr.x1]="lineWidth"
                              y1="40"
                              [attr.x2]="lineWidth - 10"
                              y2="30"
                              stroke-width="2"
                              stroke="black"></line>
                        <line [attr.x1]="lineWidth"
                              y1="40"
                              [attr.x2]="lineWidth + 10"
                              y2="30"
                              stroke-width="2"
                              stroke="black"></line>
                    </g>
                }
            </ng-container>
        }

        <!-- line connecting to downward arrow point to single task group -->
        @if (manyToOne) {
            <ng-container>
                @for (series of extraSeries; track series; let i = $index) {
                    <g [attr.transform]="('translate(' + (lineWidth * i) + ', 0)')">
                        <line x1="0" y1="20" [attr.x2]="lineWidth" y2="20" stroke-width="2" stroke="black"></line>
                        <line [attr.x1]="lineWidth"
                              y1="20"
                              [attr.x2]="lineWidth"
                              y2="0"
                              stroke-width="2"
                              stroke="black"></line>
                    </g>
                }
            </ng-container>
        }
    </g>
</svg>
